import { render, staticRenderFns } from "./society_view.vue?vue&type=template&id=68d8132e"
import script from "./society_view.vue?vue&type=script&lang=js"
export * from "./society_view.vue?vue&type=script&lang=js"
import style0 from "./society_view.vue?vue&type=style&index=0&id=68d8132e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports